import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=c2ee39fc&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.styl?vue&type=style&index=0&id=c2ee39fc&prod&lang=stylus&scoped=true&external"
import style1 from "./upload.vue?vue&type=style&index=1&id=c2ee39fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ee39fc",
  null
  
)

export default component.exports